/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * dogma_attribute object
 * @export
 * @interface GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute
 */
export interface GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute {
    /**
     * attribute_id integer
     * @type {number}
     * @memberof GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute
     */
    attributeId: number;
    /**
     * value number
     * @type {number}
     * @memberof GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute
     */
    value: number;
}

/**
 * Check if a given object implements the GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute interface.
 */
export function instanceOfGetDogmaDynamicItemsTypeIdItemIdDogmaAttribute(value: object): value is GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute {
    if (!('attributeId' in value) || value['attributeId'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeFromJSON(json: any): GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute {
    return GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeFromJSONTyped(json, false);
}

export function GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeId': json['attribute_id'],
        'value': json['value'],
    };
}

export function GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeToJSON(json: any): GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute {
    return GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeToJSONTyped(json, false);
}

export function GetDogmaDynamicItemsTypeIdItemIdDogmaAttributeToJSONTyped(value?: GetDogmaDynamicItemsTypeIdItemIdDogmaAttribute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attribute_id': value['attributeId'],
        'value': value['value'],
    };
}

